import { useEffect } from "react";

export const useChangeDocumentTitle = (pageTitle) => {
  useEffect(() => {
    document.title = `Daiki Sato
    | Personal Portfolio - ${pageTitle}`;
  }, [pageTitle]);
};
